/**
 * (配車スケジュール 新規登録/詳細) timepickr 設定値
 */
/* Define Functions */
const commonConfig = {
  timeFormat: "HH:mm",
  interval: 15,
  minTime: "00:00",
  maxTime: "23:59",
  defaultTime: "",
  startTime: "00:00",
  dynamic: false,
  dropdown: true,
  scrollbar: true,
};

export const getTimepickerConfig = (time: string) => {
  /* Get Variables. */
  const config = Object.assign({}, commonConfig);

  /* Set Time. */
  if (time) config.defaultTime = time;

  /* Return Variables. */
  return config;
};

export const setTimepickerReadOnly = (time: string, isReadOnly: boolean) => {
  /* Get Config */
  const config = getTimepickerConfig(time);

  /* Set Readonly */
  config.dropdown = isReadOnly;

  /* Return Variables. */
  return config;
};

export const replaceTimepickerElement = (id: string) => {
  let element = document.getElementById(id)!;
  let clonedElement = element.cloneNode(true);
  let parentElement = element.parentNode!;
  parentElement.replaceChild(clonedElement, element);
};

/**
 * グローバル関数を定義
 */
(window as any).getTimepickerConfig = getTimepickerConfig;
(window as any).setTimepickerReadOnly = setTimepickerReadOnly;
(window as any).replaceTimepickerElement = replaceTimepickerElement;
